export const FRIENDLY_REGEX_MESSAGES: Record<string, string> = {
  '84823391-1156-4d48-a7e6-5d2fe45129fd': 'Valor para o campo CPF invalido',
  'c69600ad-67b6-4fd1-8c19-fdf0908357c3': 'Valor para o campo email invalido.',
  '4c983223-b8ae-4ac8-81fc-fcf65fd6098d': 'Valor para o campo data de nascimento invalido',
};